module.exports = __webpack_public_path__ + "static/media/toolbar-search-icon.b64bd6a7.svg";